<template>
    <div class="comModal">
        <b-modal v-if="modalType==='input'"
                 class="inputModal"
                 :id="modalId"
                 :title="title"
                 :close-title="cancelTitle"
                 :ok-title="confirmTitle"
                 @ok="confirm"
                 @cancel="cancel"
                 @shown="focusInput">
            <b-form-input type="text"
                          v-model="inputValue"
                          @keyup.enter="confirmByEnter"></b-form-input>
            <b-alert :show="showEmptyAlert"
                     variant="danger">
                <i class="fa fa-exclamation-circle"
                   aria-hidden="true"></i>{{emptyInputAlert}}</b-alert>
        </b-modal>
    
        <b-modal v-else-if="modalType==='alert'"
                 class="alertModal"
                 :class="alertType"
                 :id="modalId"
                 title=""
                 hide-footer
                 @ok="confirm()">
            <i v-if="alertType==='fail'"
               class="fa fa-exclamation-circle"
               aria-hidden="true"></i>
            <i v-else-if="alertType==='success'"
               class="fa fa-check-circle"
               aria-hidden="true"></i> {{title}}
        </b-modal>
    
        <b-modal v-else-if="modalType==='confirm'"
                 class="confirmModal"
                 :id="modalId"
                 :title="title"
                 :close-title="cancelTitle"
                 :ok-title="confirmTitle"
                 @ok="confirm()">
        </b-modal>
    
        <b-modal v-else-if="modalType==='preview'"
                 class="previewModal"
                 :id="modalId"
                 title=""
                 size="lg"
                 hide-footer>
            <div v-html="title"></div>
            <slot name="modalContent"></slot>
        </b-modal>
    
        <b-modal v-else-if="modalType==='modal'"
                 class="originalModal"
                 :id="modalId"
                 :title="title"
                 :close-title="cancelTitle"
                 :ok-title="confirmTitle"
                 @ok="confirm()">
            <slot name="modalContent"></slot>
        </b-modal>
    
    </div>
</template>

<script>
import { log } from '@/js/function';
export default {
    props: {
        modalId: {
            type: String,
            default: 'modal',
        },
        modalType: {
            type: String,
            default: 'alert', // alert, confirm, input
        },
        alertType: {
            type: String,
            default: 'success', // success, fail
        },
        title: {
            type: String,
            default: null,
        },
        confirmTitle: {
            type: String,
            default: '確認',
        },
        cancelTitle: {
            type: String,
            default: '取消',
        },
        emptyInputAlert: {
            type: String,
            default: '請填入資料',
        },
        defaultInput: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        inputValue: '',
        showEmptyAlert: false,
    }),
    methods: {
        confirm(e) {
            if (this.modalType === 'input' && this.inputValue === '') {
                this.showEmptyAlert = true;
                document.querySelector('.inputModal input').focus();
                if (e) return e.cancel();
            } else {
                this.showEmptyAlert = false;
                this.$emit('confirm', this.inputValue);
            }
        },
        confirmByEnter() {
            this.confirm();
            if (this.inputValue) this.$root.$emit('hide::modal', this.modalId);
        },
        cancel() {
            this.showEmptyAlert = false;
        },
        focusInput() {
            this.inputValue = this.defaultInput;
            setTimeout(() => {
                document.querySelector('.inputModal input').focus();
            }, 0);
        },
    },
    beforeCreate() { },
    created() { },
    beforeMount() { },
    mounted() { },
    beforeUpdate() { },
    updated() { },
    beforeDestroy() { },
    destroyed() { },
}

</script>

<style lang="scss">
@import '../style/variable.scss';
.comModal {
    .alertModal {
        &.success {
            color: $bsGreen;
        }
        &.fail {
            color: $bsRed;
        }
    }
    .confirmModal {
        .modal-body {
            display: none;
        }
    }
    .inputModal {
        .alert {
            margin: 0;
            padding: 5px;
            i {
                margin-right: 5px;
            }
        }
    }
    .previewModal {
        .modal-header {
            display: none;
        }
        .modal-body {
            padding: 0;
        }
    }
}
</style>



// WEBPACK FOOTER //
// com-modal.vue?79485725